import type { ApiTableCommandFactory } from 'components/ApiTable/model/ApiTableModel';

export const closeAddIntentRuleForm: ApiTableCommandFactory =
  (cmdContext) => () => {
    cmdContext.updateState((draft) => {
      draft.intentVerifications.addRule = false;
    });
  };
